export default "__VITE_ASSET__BeBwg6Sx__"